import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { TitanLogo } from '@components/ui/TitanLogo'
import { useDirectionList } from '@shared/hooks/useDirectionList'
import { useLang, withLang } from '@shared/i18n/useLang'

export function Footer() {
  const { directions } = useDirectionList()
  const { t } = useTranslation()
  const lang = useLang()

  const navLinks = [
    { label: t('common.home'), to: withLang(lang, '/') },
    ...directions.map(d => ({ label: d.name, to: withLang(lang, `/napravleniya/${d.slug}`) })),
    { label: t('common.kontakty'), to: withLang(lang, '/kontakty') },
  ]

  return (
    <footer style={{ background: '#171C22', borderTop: '2px solid #189BD5' }}>
      <div className="container-page footer-grid" style={{ paddingTop: 56, paddingBottom: 0 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'flex-start' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ width: 38, height: 38, background: '#FFFFFF', borderRadius: 3, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
              <TitanLogo size={30} />
            </span>
            <span style={{ color: '#FFFFFF', fontSize: 17, fontWeight: 700, letterSpacing: '.08em' }}>{t('layout.brand')}</span>
          </div>
          <p style={{ margin: 0, color: '#93A3AE', fontSize: 13.5, lineHeight: 1.6, maxWidth: 340 }}>
            {t('footer.description')}
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ color: '#5C6670', fontSize: 11, fontWeight: 600, letterSpacing: '.14em', textTransform: 'uppercase' }}>{t('footer.sections')}</div>
          <nav style={{ display: 'flex', flexDirection: 'column', gap: 9, alignItems: 'flex-start' }}>
            {navLinks.map(l => (
              <Link key={l.to} to={l.to} style={{ color: '#C4CDD4', fontSize: 13.5, transition: 'color .15s' }}>
                {l.label}
              </Link>
            ))}
          </nav>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ color: '#5C6670', fontSize: 11, fontWeight: 600, letterSpacing: '.14em', textTransform: 'uppercase' }}>{t('footer.contacts')}</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
            <a href="tel:+70000000000" style={{ color: '#C4CDD4', fontSize: 13.5, transition: 'color .15s' }}>+7 (XXX) XXX-XX-XX</a>
            <a href="mailto:mail@titan-top.ru" style={{ color: '#C4CDD4', fontSize: 13.5, transition: 'color .15s' }}>mail@titan-top.ru</a>
            <span style={{ color: '#C4CDD4', fontSize: 13.5, lineHeight: 1.5 }}>{t('footer.address')}</span>
          </div>
        </div>
      </div>

      <div className="container-page" style={{ marginTop: 40 }}>
        <div style={{ borderTop: '1px solid #262D35', padding: '20px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
          <span style={{ color: '#5C6670', fontSize: 12 }}>{t('footer.copyright', { year: new Date().getFullYear() })}</span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <Link to={withLang(lang, '/privacy')} style={{ color: '#5C6670', fontSize: 12, transition: 'color .15s' }}>
              {t('politika.pageTitle')}
            </Link>
            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ width: 6, height: 6, background: '#189BD5' }} />
              <span style={{ color: '#5C6670', fontSize: 11, letterSpacing: '.12em', textTransform: 'uppercase' }}>{t('footer.workingSince')}</span>
            </span>
          </span>
        </div>
      </div>
    </footer>
  )
}
